import RatingPrompt from 'src/components/RatingPrompt.svelte';
import { profile_data } from 'src/stores/account/user';
import { android_version, app, network, os } from 'src/stores/session/native-bridge';
import type { ModalConfig } from 'src/types/Modals';
import { get } from 'svelte/store';
import { NoPremiumVoucherCheckRule } from './rules/NoPremiumVoucherRule';
import { compare } from 'compare-versions';
import { NativeOperationSystem } from 'src/services/init/types/init-type';

export const RatingPromptModalConfig = (forceShow = false): ModalConfig => {
	const profileData = get(profile_data);
	const activeCampaign = setLastActiveCampaign(profileData);
	let shouldShowOldModal = true;
	let hasSeenLastActiveCampaign = true;

	if (get(os) !== NativeOperationSystem.IOS) {
		shouldShowOldModal = !compare(get(android_version), '1.35.0', '>=');
	}

	if (!activeCampaign?.android?.ts) {
		hasSeenLastActiveCampaign = false;
	}

	return {
		id: 'ratePromptState',
		component: RatingPrompt,
		props: {
			priority: 30, // Low priority
			showModal: shouldShowOldModal,
			campaignId: activeCampaign?.id,
		},
		rules: [
			{
				check: () =>
					forceShow ||
					(get(app) &&
						get(network) !== 'offline' &&
						activeCampaign &&
						!hasSeenLastActiveCampaign),
				expected: true,
			},
			NoPremiumVoucherCheckRule,
		],
	};
};

function setLastActiveCampaign(profileData) {
	const now = Math.floor(Date.now() / 1000);
	const platform = get(os);
	let lastActiveCampaign = null;

	if (!profileData?.ar_campaigns) {
		return lastActiveCampaign;
	}

	for (const campaign of profileData.ar_campaigns) {
		if (campaign.ts < now && !campaign[platform]?.seen_ts) {
			const seenCampaignsWithSameId = profileData.ar_campaigns
				.filter((c) => c.id === campaign.id)
				.some((c) => c[platform]?.seen_ts);

			if (seenCampaignsWithSameId) {
				continue;
			}

			lastActiveCampaign = campaign;
			break;
		}
	}

	return lastActiveCampaign;
}
